import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserDataService } from 'src/app/services/user-data/user-data.service';
import { EventsService } from '../services/events/events.service';

@Injectable({
  providedIn: 'root'
})
export class AutoLogoutGuard implements CanActivate {

  constructor(
    private userData: UserDataService,
    private eventsService: EventsService
  ) { }
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.autoLogout();
  }
  
  async autoLogout(): Promise<boolean | UrlTree> {

    if (await this.userData.hasLoggedIn()) {
      await this.userData.removeLoginData();
      await this.userData.logoutOfGateway();
    }
    this.eventsService.publishLogout();
    return true;
  }

}
